import { Component, computed, inject, NgZone, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IqTrackingStateService } from '../state';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'iq-tracking-register',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-tracking-register.component.html',
    styleUrl: './iq-tracking-register.component.scss',
})
export class IqTrackingRegisterComponent {
    private _state: IqTrackingStateService = inject(IqTrackingStateService);
    destroy$: Subject<void> = new Subject<void>();

    /**
     * As we go on, we will need to start using zoneless implementation. Once we
     * get to an angular version, we will need to refactor this to use the zoneless
     * implementation.
     *
     *
     */
    private _zone: NgZone = inject(NgZone);

    loaded: Signal<boolean> = computed(() => {
        return this._state.initialized();
    });

    constructor() {
        this._state.initialize();

        this.getError$().subscribe((err) => {
            /**
             * Because the MFE Host Entry registers the error handler, we will skip
             * this implementation for now so we don't get duplicate errors.
             *
             * Once we migrate off the legacy log services, we can comment this back in.
             */
            // this._state.jsError(err.message, err);
        });
    }

    getError$(): Observable<Error> {
        return this._zone.onError.pipe(takeUntil(this.destroy$));
    }
}
